/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Org_Unfreeze_Confirm_AccessInputs */



/**
* | output |
* | --- |
* | "Members can sign in again immediately." |
*
* @param {Partner_Org_Unfreeze_Confirm_AccessInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_org_unfreeze_confirm_access = /** @type {((inputs?: Partner_Org_Unfreeze_Confirm_AccessInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Org_Unfreeze_Confirm_AccessInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Mitglieder können sich sofort wieder anmelden.")
	return /** @type {LocalizedString} */ ("Members can sign in again immediately.")
});